import { render, staticRenderFns } from "./LiveModal.vue?vue&type=template&id=764bc2c4&scoped=true"
import script from "./LiveModal.vue?vue&type=script&lang=js"
export * from "./LiveModal.vue?vue&type=script&lang=js"
import style0 from "./LiveModal.vue?vue&type=style&index=0&id=764bc2c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764bc2c4",
  null
  
)

export default component.exports